import { createContext } from 'react';



const LocationStringContext = createContext();


export default LocationStringContext;